module.exports = __webpack_public_path__ + "static/media/Gautham.f59a9aa2.jpg";